module.exports = __webpack_public_path__ + "img/2027_L.dea0f088.png";